// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1a2a7e18","732":"421b574d","977":"a4ebfc37"}[chunkId] + ".chunk.js";
};